export default __webpack_public_path__ + "static/media/home-logo.bc656b75.png";